import { useQuery } from '@tanstack/react-query';
import { ILegalRoleTemplate } from '../../Interfaces/ILegalRoleTemplate';
import { customFetcher } from '../useFetch';

//////////////////// LegalRoleTemplates
export const useGetLegalRoleTemplates = () => {
  const {
    data: roleTemplates,
    isLoading: isLoadingRoleTemplates,
    refetch: refetchRoleTemplates,
  } = useQuery<ILegalRoleTemplate[]>({
    refetchOnWindowFocus: false,
    queryKey: ['legalroletemplate'],
    queryFn: () =>
      customFetcher({
        endpoint: '/legalroletemplate',
      }),
  });

  return { roleTemplates, isLoadingRoleTemplates, refetchRoleTemplates };
};
